var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 2.875C29 1.29375 27.695 0 26.1 0H2.9C1.305 0 0 1.29375 0 2.875V20.125C0 21.7062 1.305 23 2.9 23H26.1C27.695 23 29 21.7062 29 20.125V2.875ZM26.1 2.875L14.5 10.0625L2.9 2.875H26.1ZM26.1 20.125H2.9V5.75L14.5 12.9375L26.1 5.75V20.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fb71eca7689ad67a972e86c4c0df690d.svg";
export { ForwardRef as ReactComponent };